/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCostCenterOci extends models.ServiceAccountNativeDetailsBaseForCostCenterCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCostCenterOci");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCostCenterOci.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCostCenterOci>): ServiceAccountNativeDetailsForCostCenterOci {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCostCenterOci(), model);
        ServiceAccountNativeDetailsForCostCenterOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCostCenterOci>): ServiceAccountNativeDetailsForCostCenterOci {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCostCenterOci.newInstance(<ServiceAccountNativeDetailsForCostCenterOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCostCenterOci) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCostCenterOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCostCenterOci): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCostCenterCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCostCenterOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id
     */
    tenant_id: string;

}
